module.exports = __webpack_public_path__ + "static/img/no-remark.eba52226.png";